import { CorpBasic, GetCorpBasic, GetCorpBasicParams } from '@/adapters/corp/GetCorpBasic'

export type CorpSignupType = 'remittance' | 'fraud'

export class CorpBasicCache {
  private static instance: CorpBasicCache

  private corpListPromises: { [signupType: string]: Promise<Array<CorpBasic>> | undefined } = {}

  private constructor () {
  }

  public static getInstance (): CorpBasicCache {
    if (!this.instance) this.instance = new CorpBasicCache()
    return this.instance
  }

  get (signupType: CorpSignupType): Promise<Array<CorpBasic>> {
    const cachedPromise = this.corpListPromises[signupType]
    if (cachedPromise) return cachedPromise
    const loadingPromise = this.load(signupType)
    this.corpListPromises[signupType] = loadingPromise
    return loadingPromise
  }

  async getCorpMap (signupType: CorpSignupType): Promise<Map<number, string>> {
    const corpList = await this.get(signupType)
    const corpMap = new Map<number, string>()
    corpList.forEach(corp => corpMap.set(corp.corp_id, corp.corp_name))
    return corpMap
  }

  private async load (signupType: CorpSignupType): Promise<Array<CorpBasic>> {
    const params: GetCorpBasicParams = signupType === 'fraud' ? { use_fraud: true } : { use_remittance: true }
    try {
      const response = await GetCorpBasic.getInstance().request(params)
      const isSuccessResponse = response.code === 200 && !!response.data
      if (!isSuccessResponse) throw new Error(`Failed to load corp list (code: ${response.code})`)
      const corpBasicList = response.data?.corp_basic || []
      // grpc-gateway serializes int64 as a JSON string, and corp_name can be absent
      // for corps without remittance history; coerce both to match the declared types
      return corpBasicList.map(corp => ({ corp_id: Number(corp.corp_id), corp_name: corp.corp_name || '' }))
    } catch (error) {
      this.corpListPromises[signupType] = undefined
      throw error
    }
  }
}
